import React from 'react';

import { createStyles, Theme, withStyles, IconButton, TextField, Button, Select, Paper, Tooltip, FormControlLabel, Checkbox, FormControl, RadioGroup, Typography, Radio } from '@material-ui/core';
import { Close, DeleteOutline } from '@material-ui/icons';
import { Print as PrintIcon} from '@material-ui/icons';

import styles from '../../attachments/attachments.module.css';
import paymentStyles from '../../paymentReport/paymentReportStyles.module.css';
import commonStyles from '../../common/common.module.css';
import MaterialTable from 'material-table';
import { PaymentAuditModel } from '../../../models/PaymentAudit';
import { formatCurrency } from '../../../utils/currencyFormatter';
import { LIST_PAYMENTS_REPORT_TYPE } from '../../../utils/listPaymentsType';
import { getAdditionalServiceDetails, getAdditionalServiceName, getPaymentSourceName } from '../../../utils/additionalServices';
import addIcon from '../../../assets/add.svg';
import moment from 'moment';
import cartStyles from '../../cart/cart.module.css';
import Awb from '../../../models/Awb';
import { PaymentDetailsAwb } from '../../../models/PaymentDetails';
import PaymentDetailsAwbs from '../../../models/PaymentDetailsAwbs';
import whsOrderDetailsStyles from '../../whs/whsOrderDetails/whsOrderDetails.module.css';
import PaymentDetailsAwbsServices from '../../../models/PaymentDetailsAwbsServices';
import Logo from '../../../assets/FD_Logo.png';
import awbStyles from './awbs.module.css';

const materialStyles = (theme: Theme) =>
  createStyles({
    wrapper: {
      borderRadius: '15px',
      marginBottom: '30px',
      padding: '20px',
      backgroundColor: 'var(--greybkg)',
    },
    header: {
      fontWeight: 600,
      color: 'var(--primaryblue)',
      fontSize: '16px',
      marginTop: '0',
      marginBottom: '0',
    },
    paper: {
      backgroundColor: 'transparent',
    },
    auditWrapper: {
      '& table': {
        padding: 0,
      },
      '& table tbody tr': {
        boxShadow: 'none',
        backgroundColor: 'green',
      },
    },
    auditSelect: {
      '& select': {
        borderRadius: 'var(--ip-br)',
        fontSize: '13px',
      },
    },
    title: {
      paddingLeft: '0px'
    },
    note: {
      marginBottom: '20px'
    },
    radioGroup: {
      display: 'flex',
      flexDirection: 'row',
      minWidth: '150px',
      justifyContent: 'space-between'
    },
    textField: {
      width: '100%',
    },
    buttonDiv: {
      marginTop: '20px'
    },
    manualEntryBtn: {
      fontSize: '50px',
      transform: 'scale(0.8)'
    },
    amountField: {
      width: '100px',
    }
  });

interface PaymentModalProps {
  classes: any;
  awb: Awb;
  payments: PaymentDetailsAwb;
  handleClose: (type: string) => void;
  printReceipt: Function;
  view: string;
};

const paymentModal = (props: PaymentModalProps) => {
  const { classes } = props;


  return (
    <div>
      <div className={[paymentStyles.overlay, awbStyles.modal].join(" ")} onClick={() => props.handleClose('payment')}></div>
      <div className={paymentStyles.auditWrapper}>

        <div className={styles.attachmentsHeader}>

          <div className={styles.titleBlk} >
            <div className={classes.title}>Payment Receipt</div>
            <div className={styles.attachmentsHeaderText}> {`${props.awb.code}-${props.awb.number} | ${props.awb.pieces} PCS | ${props.awb.weight}K  | ${props.awb.origin}-${props.awb.destination}` }</div>
          </div>
          { props.view == 'render' && <div className={styles.attachmentsButton} onClick={() => props.handleClose('payment')} >
            <IconButton aria-label="Close">
              <Close color="primary" />
            </IconButton>
          </div>}

        </div>

        <div className={`${styles.attachmentsBody}`}>
          <div className={whsOrderDetailsStyles.deliveryCompanyWrapper}>

            <div className={whsOrderDetailsStyles.driverWrapper} >
              <div className={whsOrderDetailsStyles.driverName} >
                <span className={whsOrderDetailsStyles.driverTitle}>Pieces & Weight</span>
                <span className={whsOrderDetailsStyles.driverData}>{`${props.awb.order_pieces} of ${props.awb.pieces}`}</span>
                <span className={whsOrderDetailsStyles.driverData}>{`${props.awb.order_weight}K`}</span>
              </div>
            </div>

            <div className={whsOrderDetailsStyles.driverWrapper} >
              <div className={whsOrderDetailsStyles.driverName} >
                <span className={whsOrderDetailsStyles.driverTitle}>Latest Arrival Date</span>
                <span className={whsOrderDetailsStyles.driverData}>{props.awb.arrival_date ? moment(props.awb.arrival_date).format('DD-MMM-YY').toUpperCase() : ''}</span>
              </div>
              <div className={whsOrderDetailsStyles.driverContact} >{}</div>
            </div>

              <div className={whsOrderDetailsStyles.driverWrapper} >
                <div className={whsOrderDetailsStyles.driverName}>
                  <span className={whsOrderDetailsStyles.driverTitle}>Amount Paid</span>
                  <span className={whsOrderDetailsStyles.driverData}>{ props.payments.total_amount ? formatCurrency(props.payments.total_amount , 2, '$') : '' }</span>
                </div>
              </div>
    
              <div className={whsOrderDetailsStyles.driverWrapper} >
                <div className={whsOrderDetailsStyles.driverName} >
                  <span className={whsOrderDetailsStyles.driverTitle}>Payer</span>
                  <span className={whsOrderDetailsStyles.driverData}>{props.awb.order_forwarder}</span>
                </div>
              </div>
              <div className={whsOrderDetailsStyles.driverWrapper} >
                <div className={whsOrderDetailsStyles.driverName} >
                  <span className={whsOrderDetailsStyles.driverTitle}>Payee</span>
                  <span className={whsOrderDetailsStyles.driverData}>{ props.awb.order_gha }</span>
                </div>
              </div>
          </div>
          <div className={classes.wrapper} >
            <h3 className={classes.header} >Payment Details</h3>
            <div className={`${paymentStyles.tableWrapper} ${paymentStyles.auditTableWrapper}`}>
              <MaterialTable

                components={{ Container: props => <Paper {...props} elevation={0} className={commonStyles.paperTable} /> }}

                columns={[
                  {
                    title: 'Fee', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                    render: (rowData: PaymentDetailsAwbsServices) => {

                      return <div>
                          <div  className={cartStyles.feeName}>
                          {getAdditionalServiceName(rowData.type)}:
                          {rowData.type === 'other' || rowData.type === 'gha_adjust' ? ' ' + rowData.params.reason : ''}
                        </div>
                      </div>;
                    }
                  },
                  {
                    title: 'Details', field: 'details', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                    render: (rowData: PaymentDetailsAwbsServices) => {
                      return <div>
                        <div className={cartStyles.dueRow}>
                          <div>{getAdditionalServiceDetails(rowData, Number(props.awb.weight))}</div>
                        </div>
                        </div>;
                    }
                  },
                  {
                    title: 'Amount', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top', textAlign: 'right' },
                    render: (rowData: PaymentDetailsAwbsServices) => {

                      return (
                        <div>
                          <div className={`${cartStyles.dueRow} ${commonStyles.fJustifyEnd}`}>
                          <div>$</div>
                          <div>{formatCurrency(rowData.amount, 2,)}</div>
                          </div>
                        </div>
                      )
                    }
                  },
                  {
                    title: 'Pay Method', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                    render: (rowData: any) => {

                      return <div>
                         { rowData.payment_info ? rowData.payment_info : rowData.payment_type}
                      </div>;
                    }
                  },
                  {
                    title: 'Pay Date', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                    render: (rowData: any) => {

                      return <div>
                         { moment(rowData.pay_date).format('DD-MMM-YY hh:mm').toUpperCase()}
                      </div>;
                    }
                  },
                  {
                    title: 'Paid By', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                    render: (rowData: PaymentDetailsAwbsServices) => {

                      return <div>
                         {`${props.payments.first_name} ${props.payments.last_name}`}
                      </div>;
                    }
                  },
                ]}

                data={props.payments.services}

                options={{
                  paging: false,
                  showTitle: false,
                  toolbar: false,
                  headerStyle: {
                    backgroundColor: 'var(--tbl_head_bkg)',
                    color: 'var(--tbl_head_color)',
                    zIndex: 2,
                  }
                }}
              />
            </div>
          </div>
          <div className={ awbStyles.awbFilters }>
            <img src={Logo} alt='logo' className={ `${ awbStyles.logo }` } />
           { props.view == 'render' && <IconButton aria-label="Close" onClick={ () => props.printReceipt(props.awb.code, props.awb.number)} >
              <PrintIcon color="primary" />
            </IconButton> }
          </div>
        </div>

      </div>
    </div>
  );
}

export default withStyles(materialStyles)(paymentModal);